import { dynamic } from '#/utils/dynamic';

export const authModalComponentByType = {
  EMAIL_SIGNUP: dynamic(
    () =>
      import('./EmailSignup/EmailSignupModal').then((module) => ({
        default: module.EmailSignupModal,
      })),
    { strategy: 'always' },
  ),
  VERIFY_EMAIL: dynamic(
    () =>
      import('./VerifyEmail/VerifyEmailModalContainer').then((module) => ({
        default: module.VerifyEmailModalContainer,
      })),
    { strategy: 'always' },
  ),
  VM_EMAIL_VERIFICATION: dynamic(
    () =>
      import('./VMEmailVerification/VMEmailVerificationModal').then(
        (module) => ({
          default: module.VMEmailVerificationModal,
        }),
      ),
    { strategy: 'always' },
  ),
  LOGIN: dynamic(
    () =>
      import('./Login/LoginModal').then((module) => ({
        default: module.LoginModal,
      })),
    { strategy: 'always' },
  ),
  SIGNUP: dynamic(
    () =>
      import('./Signup/SignupModal').then((module) => ({
        default: module.SignupModal,
      })),
    { strategy: 'always' },
  ),
  FORGOT_PASSWORD: dynamic(
    () =>
      import('./ForgotPassword/ForgotPasswordModalContainer').then(
        (module) => ({
          default: module.ForgotPasswordModalContainer,
        }),
      ),
    { strategy: 'always' },
  ),
  FINISH_OAUTH_SIGNUP: dynamic(
    () =>
      import('./FinishOauthSignup/FinishOauthSignupModal').then((module) => ({
        default: module.FinishOauthSignupModal,
      })),
    { strategy: 'always' },
  ),
  // TODO: move to #/auth/
  VM_POST_VERIFICATION_TOUR: dynamic(
    () =>
      import('#/components/VMOnboardingModals/VMOnboardingModals').then(
        (module) => ({ default: module.VMOnboardingModals }),
      ),
    { strategy: 'always' },
  ),
  VM_POST_VERIFICATION_INFORMATION_REQUIRED: dynamic(
    () =>
      import('#/modules/auth/modals/VMPostVerificationWelcome/VMPostVerificationWelcomeModalContainer').then(
        (module) => ({
          default: module.VMPostVerificationWelcomeModalContainer,
        }),
      ),
    { strategy: 'always' },
  ),
  VM_ORG_ADMIN_WELCOME: dynamic(
    () =>
      import('#/modules/auth/modals/VMOrgAdminWelcome/VMOrgAdminWelcomeModalContainer').then(
        (module) => ({ default: module.VMOrgAdminWelcomeModalContainer }),
      ),
    { strategy: 'always' },
  ),
} as const satisfies Record<string, unknown>;
